<template >
  <Mapbox></Mapbox>
</template>

<script>
import { clientVersion } from '../constants/env';

export default {
  components: {
    Mapbox: () => {
      if (clientVersion === 'kmrt' || clientVersion === 'thsr-main') {
        return import('@/components/map/Mapbox');
      }
      return import('@/components/map/Mapbox2');
    },
  },
};
</script>
